import api from '@/utils/api'

export function fetchList(params) {
    return api.get('wx/v1/gameNotices', { params:params })
}